import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Box, Stack, Typography } from '@mui/material'
import dayjs from 'dayjs'

import type { InsAuditChange, InsAuditChangeValue } from '@/core/models/ins-audit.model'

import { insAuditFieldMessages } from '../lib/ins-audit-labels'

type IdentityAuditChangeDetailsProps = {
  changes?: InsAuditChange[]
}

export function IdentityAuditChangeDetails({ changes }: IdentityAuditChangeDetailsProps) {
  const lingui = useLingui()

  if (!changes?.length) {
    return (
      <Typography component="div" variant="body2" color="text.secondary">
        <Trans>No field changes</Trans>
      </Typography>
    )
  }

  const formatValue = (field: string, value: InsAuditChangeValue): string => {
    if (value === null || value === '') return '—'
    if (typeof value === 'boolean') return value ? lingui._(t`Yes`) : lingui._(t`No`)
    if (field === 'userInfo.birthday' && dayjs(value).isValid()) return dayjs(value).format('DD/MM/YYYY')
    return String(value)
  }

  return (
    <Stack spacing={1}>
      {changes.map((change) => {
        const fieldMessage = insAuditFieldMessages[change.field]
        const fieldLabel = fieldMessage ? lingui._(fieldMessage) : change.field

        return (
          <Box key={change.field}>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {fieldLabel}
            </Typography>
            <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
              {formatValue(change.field, change.before)} → {formatValue(change.field, change.after)}
            </Typography>
          </Box>
        )
      })}
    </Stack>
  )
}
